import { memo } from "react";
import FilePreviewRenderer from "../../../../../../../../../../components/Common/FilePreviewRenderer";
import HtmlFilePreview from "./HtmlFilePreview";
import { getIconForFileType } from "../../../utils/fileManagement.utils";
import type { FilePreviewSectionProps } from "../../../types/fileManagement.types";

// Renders the file thumbnail or a fallback icon. Re-renders only when a different file is opened (file_id changes).
const FilePreviewSection = ({ file }: FilePreviewSectionProps) => {
  if (file?.type === "folder") return null;

  const fileType = file?.type || "";
  const fileName = file?.name || "";

  if (fileType === "html" && file?.short_url) {
    return <HtmlFilePreview fileUrl={file.short_url} fileName={fileName} />;
  }

  const thumbnailUrl = file?.thumbnails?.high;

  if (!thumbnailUrl) {
    return (
      <div className="w-full h-[140px] rounded-lg flex items-center justify-center bg-hover-effect dark:bg-hover-effect-dk">
        <img
          src={getIconForFileType(fileType)}
          alt={fileName}
          className="w-9 h-9"
        />
      </div>
    );
  }

  return (
    <FilePreviewRenderer
      url={thumbnailUrl}
      fileName={fileName}
      fileType={fileType}
    />
  );
};

const arePropsEqual = (
  prev: FilePreviewSectionProps,
  next: FilePreviewSectionProps
) => prev?.file?.file_id === next?.file?.file_id;

export default memo(FilePreviewSection, arePropsEqual);
